export const ADMIN_FILTER_KEYS = [
  "q",
  "type",
  "status",
  "language",
  "book_id",
  "ap_min",
  "ap_max",
  "asp_min",
  "asp_max",
  "kap_min",
  "kap_max",
  "feature",
  "distribution",
  "category",
  "has_image",
]

export const ADVANCED_FILTER_KEYS = [
  "ap_min",
  "ap_max",
  "asp_min",
  "asp_max",
  "kap_min",
  "kap_max",
  "feature",
  "distribution",
  "category",
  "has_image",
]

export function buildFilterUrl(baseUrl, filters) {
  const url = new URL(baseUrl, window.location.origin)

  Object.entries(filters).forEach(([key, value]) => {
    if (value !== "" && value != null) {
      url.searchParams.set(key, value)
    }
  })

  return url
}

export function hasActiveFilters(filters, basicOnly = false) {
  const keys = basicOnly
    ? ADMIN_FILTER_KEYS.filter((key) => !ADVANCED_FILTER_KEYS.includes(key))
    : ADMIN_FILTER_KEYS

  return keys.some((key) => Boolean(filters[key]))
}

export function hasActiveAdvancedFilters(filters) {
  return ADVANCED_FILTER_KEYS.some((key) => Boolean(filters[key]))
}

export function dispatchFilterChange(url, params) {
  window.dispatchEvent(
    new CustomEvent("filter:change", {
      detail: { url: url.toString(), params },
    })
  )
  window.history.pushState({}, "", url)
}
